import { Serv_send } from '../Serv/Serv.socketClient'

export async function User_fetch() {
    const { user } = await Serv_send('user.get', {})
    return user
}
